import { queryOptions } from "@tanstack/react-query";

import { getReschedulePreview } from "../services/getReschedulePreview";

const reschedulePreviewKeys = {
  root: ["reschedulePreview"] as const,
  byRescheduleUuid: (uuid: string) =>
    [...reschedulePreviewKeys.root, "detail", uuid] as const,
};

export const reschedulePreviewQuery = (rescheduleUuid: string) =>
  queryOptions({
    queryKey: reschedulePreviewKeys.byRescheduleUuid(rescheduleUuid),
    queryFn: () => getReschedulePreview(rescheduleUuid),
  });
